import React from 'react';
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function CanceledImport() {
    const {t} = usePolTranslation();

    return (
        <AdminCard title={t('canceled_import')}>
            <p>{t('import_canceled')}</p>
        </AdminCard>
    )
}
